














import mixins from 'vue-typed-mixins';
import DataSetUtils, { DataSet } from '@/utils/DataSetUtils';
import dataset from '@/router/routes/dataset';

export default mixins().extend({
  computed: {
    headers(): any {
      return [{ text: this.$tc('model.dataset.key'), value: 'key' }];
    },
  },

  data(): {
    items?: DataSet[];
  } {
    return {
      items: undefined,
    };
  },

  async mounted() {
    try {
      this.items = await DataSetUtils.api.dataset.list();
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  methods: {
    async create() {
      await this.$router.push({
        name: 'dataset-create',
      });
    },

    async edit(item: DataSet) {
      await this.$router.push({
        name: 'dataset-edit',
        params: { id: `${item.id}` },
      });
    },

    async remove(item: DataSet) {
      try {
        await this.$confirm(
          this.$i18n.t('validation.confirmation.delete', [item.key]).toString(),
          async () => {
            if (this.items) {
              await DataSetUtils.api.dataset.remove(item.id);

              this.$toast.push({
                type: 'success',
                text: this.$languageobj('validation.success.delete', {
                  values: [item.key],
                }),
              });

              const index = this.items.findIndex((val) => val.id === item.id);
              if (index >= 0) {
                this.items.splice(index, 1);
              }
            }
          }
        );
      } catch (error) {
        this.$alert.show('remove', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
